import { render } from "./MetaNavigation.vue?vue&type=template&id=7beaa61a&ts=true"
import script from "./MetaNavigation.vue?vue&type=script&lang=ts"
export * from "./MetaNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__